import _forOwn from "lodash/forOwn";
import * as Yup from "yup";
import { getDocumentsAsPerTypeOfChange } from "./transactionDocumentData";
import { Constants } from "config/constants";

export const brsUploadsValidationSchema = (requiredField, transaction) => {
  const extraValidation = getFileUploadsValidationSchemaAsPerTypeOfChange(
    requiredField,
    transaction
  );
  return Yup.object({
    brsReferenceNumber: Yup.string().required(
      "BRS Reference Number is Required"
    ),
    preSignedBusinessDocuments: Yup.object().shape({}),
  });
};

const buildYupObject = (documentsArray) => {
  let yupObj = {};
  documentsArray.forEach((doc) => {
    yupObj[doc.name] = Yup.string().required(`${doc.label} is required`);
  });
  return Yup.object().shape(yupObj);
};

const buildValidation = (
  documentsArray,
  requiredField,
  notRequiredField,
  transaction
) => {
  return Yup.object().shape({
    [requiredField]: buildYupObject(documentsArray),
    brsReferenceNumber: Yup.string().required(
      "BRS Reference Number is Required"
    ),
    [notRequiredField]: Yup.object().shape({}),

    upholdConversionResolution: Yup.boolean(),
    cancelConversionResolution: Yup.boolean(),
    registrarApproved: Yup.boolean(),
    registrarRejected: Yup.boolean(),

    // Custom validation at the root level for the checkbox group
    checkboxes: Yup.mixed().test(
      "resolution-exclusive",
      "You must select either uphold or cancel the conversion resolution",
      function () {
        const {
          upholdConversionResolution,
          cancelConversionResolution,
          fileUploads,
        } = this.parent;
        // If courtOrder exists, exactly one checkbox must be true
        if (fileUploads?.courtOrder) {
          return upholdConversionResolution !== cancelConversionResolution; // XOR: true if exactly one is true
        }
        return true; // No validation if courtOrder is not present
      }
    ),

    // Custom validation at the root level for the checkbox group
    checkboxes2: Yup.mixed().test(
      "resolution-exclusive",
      "You must select either registrarApproved or registrarRejected",
      function () {
        const { registrarApproved, registrarRejected } = this.parent;
        if (
          transaction.changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.ADMINISTRATIVE_RESTORATION &&
          transaction.status ===
            Constants.MAINTAIN_COMPANY_REVIEW_STATUSES
              .PENDING_REGISTRAR_DECISION
        ) {
          return registrarApproved !== registrarRejected;
        }
        return true;
      }
    ),
  });
};

export const getFileUploadsValidationSchemaAsPerTypeOfChange = (
  requiredField = "preSignedBusinessDocuments",
  transaction,
  changedFields = {}
) => {
  let notRequiredField = "";
  if (requiredField === "preSignedBusinessDocuments") {
    notRequiredField = "fileUploads";
  } else {
    notRequiredField = "preSignedBusinessDocuments";
  }
  const documentsArray = getDocumentsAsPerTypeOfChange(
    transaction,
    changedFields
  );
  return buildValidation(
    documentsArray,
    requiredField,
    notRequiredField,
    transaction
  );
};
